export default {
    AE: 'ОАЭ',
    BO: 'Боливия',
    CD: 'Конго',
    CF: 'ЦАР',
    FK: 'Фолклендские острова',
    FM: 'Микронезия',
    GB: 'Великобритания',
    GS: 'SGSSI',
    IO: 'BIOT',
    IR: 'Иран',
    KP: 'Северная Корея',
    KR: 'Южная Корея',
    LA: 'Лаос',
    MD: 'Молдова',
    MF: 'Saint Martin',
    PS: 'Палестина',
    RU: 'Россия',
    SX: 'Синт-Маартен',
    TW: 'Тайвань',
    TZ: 'Танзания',
    US: 'США',
    VE: 'Венесуэла',
    VG: 'Виргинские острова (Британские)',
    VI: 'Виргинские острова (США)',
};
